import classnames from 'classnames';
import { FunctionComponent } from 'react';

type PlaceholderJewelryProps = {
    className?: string;
};

const PlaceholderJewelry: FunctionComponent<PlaceholderJewelryProps> = props => {
    return (
        <svg
            className={classnames('dibsIcon', props.className)}
            data-tn={'placeholder-jewelry'}
            viewBox="0 0 250 250"
        >
            <g fill="none">
                <path
                    d="M97 4L66 34.5l33.5 37s23.5-7 50.5 0L183.5 34 154 4H97z"
                    className="jewelry-crown"
                />
                <path
                    d="M125.5 69C76.6 69 37 108.6 37 157.5S76.6 246 125.5 246s88.5-39.6 88.5-88.5S174.4 69 125.5 69zm0 159c-39 0-70.5-31.6-70.5-70.5 0-39 31.6-70.5 70.5-70.5s70.5 31.6 70.5 70.5-31.5 70.5-70.5 70.5z"
                    className="jewelry-circle"
                />
                <polyline points="183.5 34 154 4 97 4 66 34.5" className="jewelry-crown-top" />
                <polygon
                    points="118.6 67 134.6 66.791411 154.4 33 96 33"
                    className="jewelry-crown-middle"
                />
            </g>
            <g transform="translate(34)" className="jewelry-border">
                <path d="M65.9 74.8l-1.3-1.4-35.4-39.1L63.2.9h59.5l32.4 32.9-36.6 41-1.8-.5c-25.8-6.7-48.7-.1-48.9 0l-1.9.5zm26.3-9.5c7.2 0 15.5.7 24.1 2.8L146.7 34 120.1 6.9H65.6L37.5 34.5 67.8 68c3.8-.9 12.8-2.7 24.4-2.7z" />
                <path d="M91.5 249.5C41 249.5 0 208.5 0 158s41-91.5 91.5-91.5 91.5 41 91.5 91.5-41 91.5-91.5 91.5zm0-177C44.4 72.5 6 110.9 6 158s38.4 85.5 85.5 85.5S177 205.1 177 158s-38.4-85.5-85.5-85.5zm0 159C51 231.5 18 198.5 18 158s33-73.5 73.5-73.5 73.5 33 73.5 73.5-33 73.5-73.5 73.5zm0-141.1c-37.2 0-67.5 30.3-67.5 67.5s30.3 67.5 67.5 67.5 67.5-30.3 67.5-67.5-30.3-67.5-67.5-67.5z" />
                <polygon points="35.5 36.6 31.3 32.3 63.2 .9 122.6 .9 153 31.8 148.7 36 120.1 6.9 65.6 6.9" />
                <polygon points="60.144 36.676 65.342 33.679 83.823 65.732 78.626 68.729" />
                <polygon points="99.738 66.052 119.329 33.606 124.465 36.708 104.875 69.154" />
                <polygon points="36.6 31 147.1 31 147.1 37 36.6 37" />
            </g>
        </svg>
    );
};
export default PlaceholderJewelry;
